// src/data/vocabulary/sets/m1/index.js

import greetingsVocab from './greetings.json';
import courtesiesVocab from './courtesies.json';
import introductionsVocab from './introductions.json';
import contextVocab from './context.json'; 
import toBeVocab from './to_be.json';
import titlesVocab from './titles.json';
import locationsVocab from './locations.json';
import pronounsVocab from './pronouns_questions.json';
import possessivesVocab from './possessives.json';  
import countriesVocab from './countries.json';
import internationalfoodVocab from './internationalfood.json';
import landmarksVocab from './landmarks.json';
import languages from './languages.json';
import nationalities from './nationalities.json';
import travelphrases from './travelphrases.json';

export const VOCABULARY_M1_U1 = [
  greetingsVocab,
  courtesiesVocab,
  introductionsVocab,
  contextVocab,
  toBeVocab,
  titlesVocab,
  locationsVocab,
  pronounsVocab,
  possessivesVocab,
  countriesVocab,
  internationalfoodVocab,
  landmarksVocab,
  languages,
  nationalities,
  travelphrases
];
